import { render, staticRenderFns } from "./addons_update.vue?vue&type=template&id=2c2f9e56"
import script from "./addons_update.vue?vue&type=script&lang=js"
export * from "./addons_update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports